import { locale } from './globals.js';

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function(){
      return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
  }
})

class Media {
  constructor(el) {
    if(!el) return false
    this.el = el
    this.el.setAttribute('data-state', 'ready')
    this.video = this.el.querySelector('video')
    if (this.video) this.initVideo()
  }
  initVideo() {
    this.video.addEventListener('play', () => {
      this.el.setAttribute('data-state', 'playback')
    })
    this.video.addEventListener('pause', () => {
      if (this.video.ended) {
        this.el.setAttribute('data-state', 'ended')
      } else {
        this.el.setAttribute('data-state', 'ready')
      }
    })
    this.el.addEventListener('click', () => {
      if (this.video.playing) {
        this.video.pause() 
      } else {
        this.video.play()
      }
    })
  }

}

function init () {
  Array.from(document.querySelectorAll('[data-media]')).forEach(m => {
    if(!m.hasAttribute('data-state')) new Media(m)
  })
}
document.body.addEventListener('domupdated', () => init())
init()